/** First-open coach mark inside the comments popout (separate from the page tour). */
export const COMMENTS_OPEN_HELPER_STORAGE_KEY = 'lctf:commentsOpenHelper:v1';

export type CommentsOpenHelperVariant = 'group-ar' | 'group-tabs' | 'task' | 'ops';

export function hasSeenCommentsOpenHelper(): boolean {
  try {
    return !!localStorage.getItem(COMMENTS_OPEN_HELPER_STORAGE_KEY);
  } catch {
    return false;
  }
}

export function markCommentsOpenHelperSeen(): void {
  try {
    localStorage.setItem(COMMENTS_OPEN_HELPER_STORAGE_KEY, new Date().toISOString());
  } catch {
    /* private mode / quota — ignore */
  }
}

export interface CommentsOpenHelperCopy {
  title: string;
  body: string;
  anchorLabel?: string;
}

export function getCommentsOpenHelperCopy(variant: CommentsOpenHelperVariant): CommentsOpenHelperCopy {
  switch (variant) {
    case 'group-ar':
      return {
        title: 'Action required, right here',
        body: 'Assign who needs to act on each open task in this group — without leaving the thread.',
        anchorLabel: 'Action required table',
      };
    case 'group-tabs':
      return {
        title: 'One thread per group',
        body: 'Switch between Comments and PDF Comments to see everything for this group in one place.',
        anchorLabel: 'Comments tabs',
      };
    case 'ops':
      return {
        title: 'Task comments',
        body: 'The whole team’s notes for this ops task live here. Use @ to mention someone.',
      };
    case 'task':
    default:
      return {
        title: 'Group thread',
        body: 'This conversation covers the task’s whole group. New messages appear at the bottom.',
      };
  }
}
